import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  shipDate: {
    id: 'Pj1WxZ',
    defaultMessage: 'Ship Date',
    description: 'Label for the date when the shipment will be sent',
  },
  scheduledShipDate: {
    id: '3qlkWO',
    defaultMessage: 'Scheduled Ship Date:',
    description: 'Label for the planned/scheduled date when the shipment will be sent',
  },
  totalFunds: {
    id: 'JvI+7d',
    defaultMessage: 'Total Funds to Add: {totalFundsToAdd}',
    description: 'Label showing the total amount of funds that need to be added to the account',
  },
  totalPostage: {
    id: 'RF9Hmw',
    defaultMessage: 'Total Postage Cost: {totalPostageCost}',
    description: 'Label showing the total cost of postage for the shipment',
  },
  dutiesAndTaxesTooltip: {
    id: 'l6wAeq',
    defaultMessage: 'Customer is responsible for paying duties and taxes at delivery.',
    description: 'Tooltip text when duties and taxes are not billed to sender',
  },
  shipstationServicesPostage: {
    id: '/sSl6O',
    defaultMessage: 'ShipStation Services Postage Cost:',
    description: 'Label for the postage cost when using ShipStation Services as the carrier',
  },
  fundsToAdd: {
    id: 'KjQRew',
    defaultMessage: 'Funds to Add:',
    description: 'Label for the amount of funds that need to be added to complete the transaction',
  },
  surcharge: {
    id: 'vBfZq9',
    defaultMessage: 'Credit Card Processing Fee ({creditCardProcessingFeePercentage}%):',
    description: 'Label for the credit card processing fee showing the percentage charged',
  },
  carrierPostageCost: {
    id: '6r8VrF',
    defaultMessage: 'Carrier Postage Cost:',
    description: 'Label for the postage cost charged by the shipping carrier',
  },
  carrierFunds: {
    id: '1fQhyH',
    defaultMessage: 'Carrier Funds:',
    description: 'Label for funds associated with the carrier',
  },
  totalCharge: {
    id: 'kpFzQt',
    defaultMessage: 'Total Charge:',
    description: 'Label for the final total amount that will be charged for the shipment',
  },
});
